'use client';

export { default } from 'layouts/error';
